const language = {
    'pt':
    {
        add_new: 'Adicionar novo',
        archive: 'Arquivo',
        avaiable: 'Disponível até',
        abstract: 'Resumo',
        cancel: 'Cancelar', back: 'Voltar',
        close: 'Fechar',
        content: 'Evento',
        content_add: 'Adicionar bloco',
        choose_category: 'Pressione ENTER para escolher a categoria',
        content_edit: 'Editar conteúdo',
        content_new: 'Novo conteúdo',
        content_list: 'Lista de eventos',
        dates: 'Datas',
        date_creation: 'Criação',
        date_avaiable: 'Disponível até',
        date_publication: 'Publicação',
        date_last_update: 'Última atualização',
        delete: 'Eliminar',
        delete_title: 'Eliminar registo',
        delete_text: 'Continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        description: 'Descrição',
        draft: 'Rascunho',
        doc_choose: 'Carregar PDFs',
        edit: 'Editar',
        edit_title: 'Editar registo',
        edit_text: 'Continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao atualizar registo!',
        edit_success: 'Registo atualizado com sucesso!',
        file_attach: 'Attach file',
        file_remove_all: 'Remove all',
        file_upload: 'Upload file',
        file_upload_all: 'Upload all',
        filter_placeholder: 'Procurar',
        fim: 'Fim',
        hora_fim: 'Hora de fim',
        hora_inicio: 'Hora de início',
        id: 'ID',
        layout: 'Tipo',
        multimedia: 'Multimédia',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        partners: 'Parceiros',
        partners_add: 'Adicionar bloco',
        partners_edit: 'Editar parceiros',
        partners_new: 'Novo parceiros',
        partners_list: 'Lista de parceiros',
        image: 'Imagem em destaque',
        images: 'Imagens',
        image_choose: 'Carregar imagens',
        inicio: 'Início',
        insert_title: 'Novo registo',
        insert_text: 'Continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        page_config: 'Configuração da Página',
        page_parent: 'Parent',
        pages: 'Páginas',
        pdf_documents: 'Documentos PDF',
        preview: 'Pré-visualização',
        principal: 'Principal',
        published: 'Publicado',
        remove: 'Remover',
        schedule: 'Agendar',
        schedule_to: 'Agendado',
        seo_config: 'Configuração SEO',
        seo_description: 'Descrição SEO',
        seo_description_placeholder: 'Introduza a descrição',
        seo_keywords: 'Palavras-chave SEO ',
        seo_keywords_small: '(separar com vírgulas)',
        seo_keywords_placeholder: 'Introduza as palavras-chave',
        seo_title: 'Título SEO',
        seo_title_placeholder: 'Introduza o título SEO',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_title: 'Título',
        table_parent: 'Parent',
        table_date: 'Data',
        table_date_published: 'Data de publicação',
        table_state: 'Estado',
        table_actions: 'Ações',
        table_empty: 'Sem Registos',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        save: 'Salvar',
        subtitle: 'Subtítulo',
        subtitle_placeholder: 'Introduza o subtítulo',
        tlf: 'Tlf',
        tlf_placeholder: 'Introduza Tlf',
        tlm: 'Tlm',
        tlm_placeholder: 'Introduza Tlm',
        fax: 'Fax',
        fax_placeholder: 'Introduza Fax',
        email: 'E-mail',
        email_placeholder: 'Introduza E-mail',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        website: 'Website',
        website_placeholder: 'Introduza Website',
        to_eat: 'Onde Comer',
        to_sleap: 'Onde Dormir',
        partner_types: 'Tipo',
        youtube_choose: 'Youtube',
        upload_file_error: 'O ficheiro tem mais de 10MB.',
    },
    'en':
    {
        add_new: 'Add new',
        archive: 'Archive',
        avaiable: 'Avaiable until',
        abstract: 'Abstract',
        cancel: 'Cancel',
        close: 'Close',
        content: 'Event',
        content_add: 'Add block',
        choose_category: 'Press enter to add new tag',
        content_edit: 'Edit content',
        content_new: 'New content',
        content_list: 'Events list',
        dates: 'Dates',
        date_creation: 'Creation',
        date_avaiable: 'Avaiable until',
        date_publication: 'Publication',
        date_last_update: 'Last update',
        delete: 'Delete',
        delete_title: 'Delete Regist',
        delete_text: 'Are you sure you want to continue?',
        delete_confirm: 'Yes',
        delete_cancel: 'No',
        delete_error: 'Problem deleting the element!',
        delete_success: 'Element deleted successfully!',
        description: 'Description',
        draft: 'Draft',
        doc_choose: 'Choose PDF',
        edit: 'Edit',
        edit_title: 'Edit Regist',
        edit_text: 'Are you sure you want to continue?',
        edit_confirm: 'Yes',
        edit_cancel: 'No',
        edit_error: 'Problem updating element!',
        edit_success: 'Successful updated element!',
        file_attach: 'Attach file',
        file_remove_all: 'Remove all',
        file_upload: 'Upload file',
        file_upload_all: 'Upload all',
        filter_placeholder: 'Search',
        fim: 'Fim',
        hora_fim: 'Hora de fim',
        hora_inicio: 'Hora de início',
        id: 'ID',
        layout: 'Type',
        multimedia: 'Multimedia',
        name: 'Name',
        name_placeholder: 'Insert the name',
        partners: 'Parceitos',
        partners_add: 'Adicionar bloco',
        partners_edit: 'Editar parceiros',
        partners_new: 'Novo parceiros',
        partners_list: 'Lista de parceiros',
        image: 'Highlight image',
        images: 'Images',
        image_choose: 'Choose image',
        inicio: 'Início',
        insert_title: 'New Regist',
        insert_text: 'Are you sure you want to continue?',
        insert_confirm: 'Yes',
        insert_cancel: 'No',
        insert_error: 'Problem updating element!',
        insert_success: 'Successful updated element!',
        page_config: 'Page config',
        page_parent: 'Parent',
        pages: 'Pages',
        pdf_documents: 'PDF Documents',
        preview: 'Preview',
        principal: 'Principal',
        published: 'Publicado',
        remove: 'Remove',
        schedule: 'Schedule',
        schedule_to: 'Schedule',
        seo_config: 'SEO config',
        seo_description: 'SEO description',
        seo_description_placeholder: 'Insert the SEO description',
        seo_keywords: 'SEO keywords',
        seo_keywords_small: '(separate by comma)',
        seo_keywords_placeholder: 'Insert the SEO keywords',
        seo_title: 'SEO title',
        seo_title_placeholder: 'Insert the SEO title',
        table_rows_per_page: 'Regist by page:',
        table_separator: 'of',
        table_all: 'All',
        table_title: 'Title',
        table_parent: 'Parent',
        table_date: 'Date',
        table_date_published: 'Published date',
        table_state: 'State',
        table_actions: 'Actions',
        table_empty: 'No Records',
        text: 'Text',
        title: 'Title',
        title_placeholder: 'Insert title',
        save: 'Save',
        subtitle: 'Subtitle',
        subtitle_placeholder: 'Insert subtitle',
        tlf: 'Tlf',
        tlf_placeholder: 'Introduzir Tlf',
        tlm: 'Tlm',
        tlm_placeholder: 'Introduzir Tlm',
        fax: 'Fax',
        fax_placeholder: 'Introduzir Fax',
        email: 'E-mail',
        email_placeholder: 'Introduzir E-mail',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        website: 'Website',
        website_placeholder: 'Introduzir Website',
        to_eat: 'Onde Comer',
        to_sleap: 'Onde Dormir',
        partner_types: 'Tipo',
        youtube_choose: 'Youtube',
        upload_file_error: 'O ficheiro tem mais de 10MB.',
    }
}

module.exports = {
    language
};